import type { PostDto, PublishJobDto } from '@str/api/types';
import { CHANNEL_META, PLAN_ENDED_MESSAGE, type Channel } from '@str/shared';

export const JOB_STATUS: Record<
  PublishJobDto['status'],
  { label: string; color: string; bg: string }
> = {
  queued: { label: 'Queued', color: '#555', bg: '#f1efe9' },
  publishing: { label: 'Publishing…', color: '#5a3a22', bg: '#fbf1e8' },
  pending: { label: 'Processing…', color: '#5a3a22', bg: '#fbf1e8' },
  published: { label: 'Published', color: '#2f7a4a', bg: '#e8f3ec' },
  failed: { label: 'Failed', color: '#a33a2a', bg: '#fbeae7' },
  unconfirmed: { label: 'Unconfirmed', color: '#a33a2a', bg: '#fbeae7' },
  skipped: { label: 'Not connected', color: '#777', bg: '#f1efe9' },
};

/** "IG ✓ · FB processing" style one-liner for cards. */
export function jobSummary(p: PostDto): string | null {
  if (!p.publishJobs.length) return null;
  return p.publishJobs
    .map((j) => {
      const s = JOB_STATUS[j.status].label.replace('…', '');
      return `${j.channel} ${j.status === 'published' ? '✓' : s.toLowerCase()}`;
    })
    .join(' · ');
}

/** The platform's refusal in the host's words: a signed-out account says so; the rest stays short. */
export function publishFailure(error: string | null | undefined, channels: Channel[]): string {
  const name = channels[0] ? CHANNEL_META[channels[0]].label : 'The channel';
  if (!error) return 'No channel accepted it.';
  // Not the channel's refusal: the plan ended, so nothing was sent.
  if (error === PLAN_ENDED_MESSAGE) return error;
  if (
    /invalidated|login expired|session has been invalidated|code 190|reauth|reconnect/i.test(error)
  )
    return `${name} signed this account out. Reconnect it on Channels, then post again.`;
  const short = error.length > 140 ? `${error.slice(0, 140)}…` : error;
  return `${name} did not accept it: ${short}`;
}
